/** @format */
import { get, post, download } from '@root/utils/httpWrap';

// import { AxiosPromise } from 'axios'
// import { setHttp } from '../../../utils/http'
// const http = setHttp({}, '')

/**
 * 车场列表查询
 */
export const queryParkingLotList = (params: any): Promise<ProjectResponse<any>> => {
  // return http.post(`/bangdao/saasapi/v1/basePark/list`, params)
  return post('/bangdao/saasapi/v1/basePark/list', params);
};

/**
 * 车场列表导出
 */
export const exportParkingLotList = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/basePark/export', params);
};

/**
 * 车场详情查询
 */
export const queryParkingLot = (params: any): Promise<ProjectResponse<any>> => {
  return post(`/bangdao/saasapi/v1/basePark/detail`, params);
};
/**
 * 车场信息编辑详情
 */
export const editInfoParkingLot = (params: any): Promise<ProjectResponse<any>> => {
  return post(`/bangdao/saasapi/v1/basePark/editInfo`, params);
};
// 车场新增编辑入参
export interface IQueryParkingIotAddOrEditParam {
  parkId?: string;
  parkName: string;
  projectName: string;
  organId: string;
  projectCode: string;
  parkType: string;
  deviceProvider: string;
  contacts: string;
  phoneNumber: string;
  provinceId: string;
  cityId: string;
  areaId: string;
  address: string;
  businessId: string;
  longitude: string;
  latitude: string;
  images: string[];
}
/**
 * 车场编辑
 */
export const editParkingLot = (params: any): Promise<ProjectResponse<any>> => {
  return post(`/bangdao/saasapi/v1/basePark/edit`, params);
};
/**
 * 车场IOT
 */
export const pageList = (params: any): Promise<ProjectResponse<any>> => {
  return post(`/bangdao/saasapi/v1/iot/pageList`, params);
};
/**
 * 车场新增
 */
export const createParkingLot = (params: any): Promise<ProjectResponse<any>> => {
  return post(`/bangdao/saasapi/v1/basePark/add`, params);
};
/**
 * 车场信息运营状态切换
 */
export const changeStatus = (params: any): Promise<ProjectResponse<any>> => {
  return post(`/bangdao/saasapi/v1/basePark/changeStatus`, params);
};
/**
 * 区域列表查询
 */
export const queryAreaList = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseArea/list', params);
};

/**
 * 新增或编辑区域
 */
export const addOrEditArea = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseArea/addOrEdit', params);
};
/**
 * 区域编辑详情
 */
export const queryArea = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseArea/editInfo', params);
};
/**
 * 区域删除
 */
export const deleteArea = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseArea/delete', params);
};

/**
 * 区域列表导出
 */
export const exportAreaList = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseArea/export', params);
};

/**
 * 设备列表查询
 */
export const queryDeviceList = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseDevice/list', params);
};
/**
 * 设备编辑详情
 */
export const editInfoDeviceList = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseDevice/editInfo', params);
};
/**
 * 设备新增或者修改
 */
export const addOrEditDeviceList = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseDevice/addOrEdit', params);
};
/**
 * 设备删除
 */
export const deleteDeviceList = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseDevice/delete', params);
};
/**
 * 设备停用
 */
export const forbidDeviceList = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseDevice/forbid', params);
};
/**
 * 设备列表导出
 */
export const exportDeviceList = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseDevice/export', params);
};
/**
 * 通道停用
 */
export const forbidChannelList = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseChannel/forbid', params);
};
/**
 * 通道列表查询
 */
export const queryChannelList = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseChannel/list', params);
};
/**
 * 通道编辑详情
 */
export const editInfoChannelList = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseChannel/editInfo', params);
};
/**
 * 通道详情
 */
export const detailChannelList = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseChannel/detail', params);
};

/**
 * 新增或编辑通道
 */
export const addOrEditChannelList = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseChannel/addOrEdit', params);
};

/**
 * 通道删除
 */
export const deleteChannelList = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseChannel/delete', params);
};

/**
 * 通道列表导出
 */
export const exportChannelList = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseChannel/export', params);
};

/**
 * 根据车场获取对应区域
 */
export const getAreasList = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseChannel/getAreas', params);
};
/**
 * 根据车场和区域获取相关设备
 */
export const getDeviceListByParkAndArea = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseChannel/getDeviceByParkAndArea', params);
};

/**
 * 车场和区域列表
 */
export const getParkAreaList = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseChannel/getParkArea', params);
};

/**
 * 设置短码
 */
export const setShortCode = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseChannel/setShortCode', params);
};

/**
 * 设置短码
 */
export const enableOrDisabledShortCode = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseChannel/enableOrDisabledShortCode', params);
};

/**
 * 获取车辆类型 /bangdao/saasapi/v1/baseChannel/getForbidCars
 */
export const getCarType = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseChannel/getCarType', params);
};
/**
 * 获取车辆类型
 */
export const getForbidCars = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseChannel/getForbidCars', params);
};

/**
 * 通道限制自定义
 */
export const channelForbid = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseChannel/channelForbid', params);
};
/**
 * 通道授权详情
 */
export const getForbidDetail = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseChannel/getForbidDetail', params);
};
/**
 * 省市区
 */
export const getRegion = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/basePark/getRegion', params);
};
/**
 * 社区代码
 */
export const getcommunityCode = (): Promise<any> => {
  return get('/bangdao/saasapi/v1/basePark/getAccountTree');
};
/**
 * 车场管理-岗亭人员信息列表
 */
export const querySentryList = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseSentryAccount/list', params);
};
/**
 * 车场管理-岗亭人员编辑详情
 */
export const editInfoSentry = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseSentryAccount/editInfo', params);
};
/**
 * 车场管理-岗亭人员信息新增或修改
 */
export const addOrEditSentry = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseSentryAccount/addOrEdit', params);
};
/**
 * 车场管理-岗亭人员信息-修改密码
 */
export const editPasswordSentry = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseSentryAccount/editPassword', params);
};
/**
 * 车场管理-岗亭人员信息-禁用启用
 */
export const disableOrEnableSentry = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseSentryAccount/disableOrEnable', params);
};
/**
 * 车场管理-岗亭人员信息-删除
 */
export const deleteSentry = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseSentryAccount/delete', params);
};
/** 计费规则*/
/**
 * 查看规则
 */
export const getById = (params: any): Promise<ProjectResponse<any>> => {
  console.log(345678987654567);
  return post('/bangdao/saasapi/v1/chargeRule/getById', params);
};
/**
 * 添加规则
 */
export const addRule = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/chargeRule/addRule', params);
};
/**
 * 列表
 */
export const loadAllRulesList = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/chargeRule/loadAllRules', params);
};
/**
 * 更新状态
 */
export const updateStatus = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/chargeRule/updateStatus', params);
};
//岗亭信息列表
export const baseSentryList = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseSentry/list', params);
};
// 岗亭信息详情 /bangdao/saasapi/v1/baseSentry/editInfo
export const baseSentryInfo = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseSentry/editInfo', params);
};
//岗亭信息编辑新增
export const baseSentryAddOrEdit = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseSentry/addOrEdit', params);
};
// 根据车场ID获取对应区域信息/bangdao/saasapi/v1/baseArea/findAreaByParkId
export const findAreaByParkId = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseArea/findAreaByParkId', params);
};
//根据区域信息获取对应通道信息 /bangdao/saasapi/v1/baseChannel/findChannelByAreaId
export const findChannelByAreaId = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseChannel/findChannelByAreaId', params);
};
//岗亭信息 绑定通道/bangdao/saasapi/v1/baseSentry/bindChannel
export const bindChannel = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseSentry/bindChannel', params);
};
//岗亭信息 禁用启用 /bangdao/saasapi/v1/baseSentry/disableOrEnable
export const disableOrEnable = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseSentry/disableOrEnable', params);
};
//根据车场信息获取对应通道信息 bangdao/saasapi/v1/baseChannel/findChannelByParkId
export const findChannelByParkId = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseChannel/findChannelByParkId', params);
};
//返回已选择通道ID bangdao/saasapi/v1/baseSentry/checkedChannels
export const checkedChannels = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseSentry/checkedChannels', params);
};
//车场操作记录 /bangdao/saasapi/v1/operationRecord/list
export const operationRecordList = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/operatRecord/getList', params);
};
//岗亭信息删除
export const baseSentryDelete = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseSentry/delete', params);
};
// 车场列表 /bangdao/saasapi/v1/baseParkEvent/list
export const baseParkEvent = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseParkEvent/list', params);
};
// 车场事件导出 /bangdao/saasapi/v1/baseParkEvent/export
export const exportBaseParkEvent = (params: any, fileName?: string): Promise<ProjectResponse<any>> => {
  return download('/bangdao/saasapi/v1/baseParkEvent/export', params, fileName);
};
/**
 * 车场模板下载
 */
export const baseDeviceTemplate = (params?: any, fileName?: string): any => {
  return download('/bangdao/saasapi/v1/baseDevice/template', params, fileName);
};
/**
 * 车场导出
 */
export const baseDeviceExport = (params: any, fileName?: string): any => {
  return download('/bangdao/saasapi/v1/baseDevice/excelExport', params, fileName);
};
/**
 * iot配置修改
 */
export const iotConfigUpdate = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/system/sysiotparkingconfig/update', params);
};
/**
 * iot配置列表
 */
export const iotConfigList = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/system/sysiotparkingconfig/list', params);
};
//获取图片需要传的参数
export interface uploadImage {
  parkId: string;
  fileName: string;
  modelId: string;
}
// 获取图片
export const getImgSrc = (params: uploadImage): any => {
  return post('/bangdao/saasapi/v1/image/getImage', params);
};

/**
 * real车场导出
 */
export const downloadexport = (params: any, fileName?: string): any => {
  return download('/bangdao/saasapi/v1/basePark/export', params, fileName);
};
/**
 * 项目名称列表
 */
export const projectList = (): Promise<any> => {
  return get('/bangdao/saasapi/v1/basePark/getProjectList');
};
/**
 * 项目详情
 */
export const projectInfo = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/basePark/getProjectInfo', params);
};
/**
 * 获取设备列表
 */
export const deviceInfo = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseDevice/getDeviceInfo', params);
};
/**
 * 车场信息二维码
 */
export const getParkQRCode = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/basePark/getQRCode', params);
};
/**
 * 通道信息二维码
 */
export const getChannelQRCode = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseChannel/getQRCode', params);
};
/**
 * 项目列表
 */
export const getProjectListInfo = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/basePark/getNewHopeProjectInfo', params);
};
